import React from 'react';
import config from '@utils/config';
import { Helmet } from 'react-helmet';

const SEO = ({ title, uri, desc }) => {
  return (
    <Helmet>
      {title && (
        <title itemProp="name" lang="en">
          {title + ' | ' + config.siteTitle}
        </title>
      )}
      {uri && (
        <link rel="canonical" href={`https://dynamo-fencing.com/${uri}`} />
      )}
      {desc && <meta name="description" content={desc} />}
    </Helmet>
  );
};

export default SEO;
